<template>
  <div>
    <section class="section is-main-section">
      <CardComponent>
        <div class="section has-text-centered">
          <h1 class="title">Import Media</h1>
        </div>
        <div class="columns is-vcentered">
          <div class="column is-6 is-offset-3">
            <div class="flex-card light-bordered light-raised">
              <div class="card-body">
                <ValidationObserver ref="observer" v-slot="{ passes }">
                  <form @submit.prevent="passes(importUrl)">
                    <div class="columns is-multiline">
                      <div class="column is-12">
                        <div class="control">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Import URL"
                            rules="required"
                          >
                            <b-field
                              label="Import URL"
                              :type="{ 'is-danger': errors.length > 0 }"
                              :message="errors[0]"
                            >
                              <b-input v-model="url" />
                            </b-field>
                          </ValidationProvider>
                        </div>
                      </div>
                    </div>
                    <div class="has-text-centered">
                      <div class="is-block has-margin-bottom-15">
                        <b-button
                          icon-left="arrow-left"
                          class="is-medium has-margin-right-10"
                          tag="router-link"
                          :to="{ name: 'ManageMedia' }"
                        >
                          Back to List</b-button
                        >
                        <button
                          class="button is-primary is-medium btn-align no-lh raised primary-btn"
                          type="submit"
                          :disabled="loading"
                          :class="{ 'is-loading': loading }"
                        >
                          Import
                        </button>
                      </div>
                    </div>
                  </form>
                </ValidationObserver>
              </div>
            </div>
          </div>
        </div>
      </CardComponent>
    </section>
  </div>
</template>

<script>
import CardComponent from '@/components/CardComponent'
import MediaApi from '@/api/media'

export default {
  name: 'ImportMedia',
  components: {
    CardComponent
  },
  metaInfo: {
    title: 'Import Media'
  },
  data() {
    return {
      loading: false,
      url: ''
    }
  },
  methods: {
    importUrl() {
      this.loading = true
      MediaApi.importUrl(this.url)
        .then(response => {
          this.$buefy.toast.open({
            message: `${response.count} items imported successfully!`,
            position: 'is-top',
            type: 'is-success'
          })
          this.loading = false
        })
        .catch(err => {
          console.log(err)
          this.$buefy.toast.open({
            message: 'Error importing media',
            position: 'is-top',
            type: 'is-danger'
          })
          this.loading = false
        })
    }
  }
}
</script>
